module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-inner-1450.5b83bc3c.svg";